module.exports = __webpack_public_path__ + "static/media/apple.f136f5cc.svg";